export const techniciansConstant = {
  INSERT_REQUEST: 'TECHNICIANS_INSERT_REQUEST',
  INSERT_SUCCESS: 'TECHNICIANS_INSERT_SUCCESS',
  INSERT_FAILURE: 'TECHNICIANS_INSERT_FAILURE',

  GET_ALL_REQUEST: 'TECHNICIANS_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'TECHNICIANS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TECHNICIANS_GET_ALL_FAILURE',
}
